import React from 'react'
import { IMapper, TimeZoneProvider, useMapper } from '@fareye/common'
import { IPageRenderConfig } from '@fareye/types'
import { RenderControl } from '@fareye/ui'
import version from '../../../config/npmVersions'
import { MultiModalOpsDashboard } from './MultiModalOpsDashboard'

export function MultiModalOpsDashboardMapper(props: IMapper) {
  const [apiData, _] = useMapper({ ...props, version })
  return (
    <TimeZoneProvider>
      <RenderControl variant="m" state={apiData}>
        <MultiModalOpsDashboard
          {...props}
          config={apiData.data as IPageRenderConfig}
        />
      </RenderControl>
    </TimeZoneProvider>
  )
}